'use strict'
import { codeData } from '@/utils/codeData';

const invoice = {
    path: 'invoice-manage',
    name: 'invoice-manage',
    meta: {
        title: '发票管理-发票管理-综合服务平台',
        name: '发票管理',
        tagsTitle: '发票管理',
        code: ''
    },
    redirect: {
        name: 'invoice-record-list'
    },
    component: () => import('@/components/RouterView'),
    children: [
        {
            path: '',
            name: 'invoice-record-list',
            meta: {
                title: '发票管理-发票管理-综合服务平台',
                name: '',
                tagsTitle: '发票管理',
                code: ''
            },
            component: () => import('@/pages/invoice/List'),
        },
        {
            path: ':id',
            name: 'invoice-record-details',
            meta: {
                title: '发票记录-发票管理-综合服务平台',
                name: '详情',
                tagsTitle: '发票记录详情',
                code: ''
            },
            component: () => import('@/pages/invoice/RecordDetails'),
        },

    ]
};

export default invoice;